import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],

  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    data: {}
  }),

  watch: {
    chartData () {
      this.data = this.chartData
      this.$data._chart.update()
    }
  },

  mounted () {
    this.data = this.chartData
    this.renderTheChart()
  },

  methods: {
    renderTheChart() {
      this.renderChart(this.data, this.options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/charts/BarChart.js